import React from "react";
import { Button } from "../../../../../ui/components/Button";
import type { DocumentEntityType } from "../../../domain/entities/DocumentChangeAuditEntity";

export interface DocumentChangeFiltersState {
  entityType: "" | DocumentEntityType;
}

interface DocumentChangeFiltersProps {
  filters: DocumentChangeFiltersState;
  onChange: (filters: DocumentChangeFiltersState) => void;
  loading?: boolean;
}

const ENTITY_TYPE_OPTIONS: Array<{
  value: DocumentChangeFiltersState["entityType"];
  label: string;
}> = [
  { value: "", label: "All" },
  { value: "bill", label: "Bills" },
  { value: "invoice", label: "Invoices" },
];

export const DocumentChangeFilters: React.FC<DocumentChangeFiltersProps> = ({
  filters,
  onChange,
  loading = false,
}) => {
  return (
    <div className="flex w-full flex-wrap items-end gap-6">
      <div className="flex flex-col gap-1.5">
        <span className="text-caption font-caption text-subtext-color">
          Document type
        </span>
        <div className="flex items-center gap-2">
          {ENTITY_TYPE_OPTIONS.map((option) => (
            <Button
              key={option.value || "all-type"}
              variant={
                filters.entityType === option.value
                  ? "brand-primary"
                  : "neutral-secondary"
              }
              size="small"
              disabled={loading}
              onClick={() =>
                onChange({ ...filters, entityType: option.value })
              }
            >
              {option.label}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
};
